@if (authService.isAuthLoading()) {
    <si-loading-spinner [isBlockingSpinner]="true" [isSpinnerOverlay]="true" ariaLabel="Loading..." />
}

@if (isRouterPathUnauthorized() || isRouterPathNotFound()) {
    <div class="h-screen">
        <router-outlet />
    </div>
} @else {
    <div class="has-navbar-fixed-top si-layout-fixed-height h-screen overflow-hidden flex flex-col">
        <si-application-header>
            <si-header-brand>
                <a siHeaderLogo routerLink="/" class="d-none d-md-flex"></a>
                <h1 class="application-name">JUNO Mailing Suite</h1>
            </si-header-brand>

            <si-header-actions>
                <app-language-switcher></app-language-switcher>
                <app-theme-toggle></app-theme-toggle>
                <app-support-link></app-support-link>
                <app-user></app-user>
            </si-header-actions>
        </si-application-header>

        <si-navbar-vertical
            class="si-layout-fixed-height"
            navbarCollapseButtonText="collapse"
            navbarExpandButtonText="expand"
            [items]="navbarItems()"
        >
            <div class="si-layout-fixed-height juno-main-content overflow-hidden px-4" id="main-content">
                <div class="juno-main-content-scroll">
                    <router-outlet />
                </div>
                <si-footer class="flex-shrink-0" [copyright]="footerCopyright" [links]="footerItems" />
            </div>
        </si-navbar-vertical>
    </div>
}
